import axios from "axios";

export const getQueryHeaders = (integratorId?: string, requestId?: string) => {
  return {
    ...(integratorId ? { "X-Integrator-Id": integratorId } : {}),
    ...(requestId ? { "X-Request-Id": requestId } : {}),
  };
};

export const getStatusCode = (error: any) => {
  if (axios.isAxiosError(error)) {
    return error.response?.status;
  }
  return undefined;
};

export const is404Error = (error: any) => {
  const statusCode = getStatusCode(error);
  if (statusCode === 404) {
    return true;
  }
  return false;
};
